import { Component, Input, TemplateRef, ViewChild, forwardRef } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { BehaviorSubject } from 'rxjs';
import { GraphqlApiService, RoleService, System } from 'ngx-core-services';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ApplyPipeModule, TooltipModule } from 'ngx-zcs-components';
import { HeaderOptionsModule } from 'ngx-zcs-blocks';
import { MatButtonModule } from '@angular/material/button';

import {
  AppsyncEnvSelectorComponent,
  LanguageSelectorComponent,
  RefreshSelectorComponent,
  SearchSystemComponent,
  PlantCardListComponent,
} from '@customerComponents';

import { SharedModule } from '../../shared.module';
import { LanguageService, RefreshService, ScreenType } from '../../services';
import { ShortName } from './header-nav.utils';

@Component({
  standalone: true,
  imports: [
    ApplyPipeModule,
    AppsyncEnvSelectorComponent,
    CommonModule,
    forwardRef(() => HeaderOptionsModule),
    LanguageSelectorComponent,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    RefreshSelectorComponent,
    RouterModule,
    SearchSystemComponent,
    SharedModule,
    PlantCardListComponent,
    TooltipModule,
  ],
  selector: 'customer-header-nav',
  templateUrl: './header-nav.component.html',
  styleUrls: ['./header-nav.component.scss'],
})
export class HeaderNavComponent {
  @ViewChild('mobileSystemCardList') mobileSystemCardList: TemplateRef<any> | null = null;
  @ViewChild('mobileSearchSystem') mobileSearchSystem: TemplateRef<any> | null = null;

  @Input() user?: {
    email: string | null;
    photoURL: string | null;
    displayName: string | null;
  } | null;
  @Input() toggleSidebar?: () => void;
  @Input() toggleSidebarRight?: () => void;
  @Input() screenType: ScreenType = 'medium';
  @Input() set systems(value: System[] | undefined | null) {
    this._systems$.next(value);
  }
  get systems(): System[] | undefined | null {
    return this._systems$.value;
  }
  @Input() selectedSystem?: System | null;
  @Input() search = '';
  @Input() options = {
    showMyPlants: true,
    showNewPlant: true,
  };

  readonly _systems$ = new BehaviorSubject<System[] | undefined | null>(undefined);
  readonly currentLang$ = this.languageService.currentLang$;
  readonly is_developer$ = this.roleService.is_developer$;
  readonly envGateway$ = this.graphqlApiService.envGateway$;
  readonly ShortName = ShortName;
  readonly tooltipsTemplatePosition: Partial<ConnectedPosition> = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
    offsetY: 4,
  };

  constructor(
    private readonly dialog: MatDialog,
    private readonly graphqlApiService: GraphqlApiService,
    private readonly roleService: RoleService,
    readonly languageService: LanguageService,
    readonly refreshService: RefreshService,
  ) { }

  openMobileSearch() {
    if (!this.mobileSearchSystem) {
      return;
    }

    this.dialog.open(this.mobileSearchSystem, {
      position: { top: '30px' },
      data: {
        systems: this.systems,
        query: this.search,
      },
    });
  }

  openMobileChoosePlant() {
    if (!this.mobileSystemCardList) {
      return;
    }

    this.dialog.open(this.mobileSystemCardList, {
      position: { top: '30px' },
      data: this.systems,
    });
  }
}
